import { useTokenContext } from 'contexts/resource/ResourceContext';

const useFormatCurrency = () => {
  const { currencyVal, numberingFormat } = useTokenContext();

  const formatCurrency = (data: string | number): string => {
    let number = typeof data === 'string' ? Number(data) : data;

    const isNegative = number < 0;

    if (isNegative) {
      number = Math.abs(number);
    }

    const locale = numberingFormat === 'indian' ? 'en-IN' : 'en-US';
    const formattedNumber = number?.toLocaleString(locale, {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
    return isNegative
      ? `-${currencyVal} ${formattedNumber}`
      : `${currencyVal} ${formattedNumber}`;
  };

  return formatCurrency;
};

export default useFormatCurrency;
